<template>
    <authenticated-layout>
        <v-card class="pa-6">
            <div class="overflow-x-auto">
                <table style="table-layout: auto;">
                    <tr>
                        <th
                            v-for="(header, index) in headers"
                            :key="`table-header-${index}`"
                        >
                            {{ header }}
                        </th>
                    </tr>

                    <tr v-for="row in entries" :key="`entry-${row.id}`">
                        <td>{{ row.id }}</td>
                        <td>{{row.name}}</td>
                        <td>{{$numberHelper.formatMoney(row.buying_price_current)}}</td>
                        <td>{{$numberHelper.formatMoney(row.buying_price_current * margin)}}</td>
                        <td>{{row.quantity_current}}</td>
                        <td>{{row.quantity_last}}</td>
                        <td>€{{row.buying_price_last}}</td>
                        <td>{{row.is_in_stock}}</td>
                        <td>{{moment(row.created_at).format("DD/MM/YY h:mm")}}</td>
                        <td>{{moment(row.updated_at).format("DD/MM/YY h:mm")}}</td>
                    </tr>
                </table>
            </div>
        </v-card>
    </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated";
import moment from 'moment';

export default {
    components: {
        AuthenticatedLayout,
        moment,
    },
    props: ["entries"],
    data() {
        return {
            margin: 1.05,
            moment: moment,
            headers: [
                "ID",
                "Name",
                "Buying Price [PLN]",
                "Selling Price with margin",
                "Quantity",
                "Quantity - last",
                "Buying Price [EUR] - last",
                "Is in stock",
                "Created at",
                "Updated at"
            ]
        };
    },
    computed: {
    },
    methods: {

    },
};
</script>

<style scoped>
table {
    width: 100%;
    table-layout: fixed;
    font-size: 12px;
}

@media screen and (max-width: 1024px) {
    table {
        width: auto;
    }
}

th {
    padding: 10px 0px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
    box-sizing: border-box;
    padding-left: 10px;
    border-bottom: 1px solid #aaa;
}

td {
    text-align: left;
    box-sizing: border-box;
    padding: 5px 0px;
    padding-left: 10px;
    border-bottom: 1px solid #ccc;
}
</style>
